import { render, staticRenderFns } from "./mb-guide.vue?vue&type=template&id=14af0799&"
import script from "./mb-guide.vue?vue&type=script&lang=js&"
export * from "./mb-guide.vue?vue&type=script&lang=js&"
import style0 from "./mb-guide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports